import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/Base/Card";
import { useStore } from "@/stores/useStore";
import { CreateShopButton } from "@/components/Onboarding/CreateShopButton";
import { SupportLink } from "@/components/Common/SupportLink";

type NotAssociatedViewProps = {
  onClick?: () => void;
};

export const NotAssociatedView = ({ onClick }: NotAssociatedViewProps) => {
  const { user } = useStore();
  const displayName = user?.displayName
    ? user?.displayName
    : (user?.firstName ?? "");
  return (
    <Card variant={"bordered"}>
      <CardHeader>
        <CardTitle>Welcome {displayName}</CardTitle>
        <CardDescription className="text-primary-foreground">
          It does not look like you are associated with a shop yet. You can
          either sit tight and wait for an invitation to a shop, or you can
          create a new shop. If you think this is an error, you can reach out to{" "}
          <SupportLink className={"underline"}>support</SupportLink>
        </CardDescription>
      </CardHeader>
      <CardContent>
        <CreateShopButton onClick={onClick} />
      </CardContent>
    </Card>
  );
};
